const state = {
    map: null,
}

const mutations = {
    addToActiveLayers(state, payload) {
        state.layers[payload.layer].push({
            layer: payload.data
        })
    },

    removeLayerFromActiveLayers(state, payload) {
        var index = state.layers[payload.layer].indexOf(payload.data);
        state.layers[payload.layer].splice(index, 1)
    },

    removeLayerFromMap(state, payload) {
        state.map.removeLayer(payload.layer)
    },

    moveLayer(state, payload) {
        state.map.moveLayer(payload.layer, payload.beforeLayer)
    },

    changeLayerOpacity(state, payload) {
        state.map.setPaintProperty(payload.layer, payload.layerType, payload.opacity)
    }

}

export default {
    state,
    mutations
}
